import { SelectOption, User } from '@hefe/models';
import {
  BasketballUsersSlice,
  currentUserSelector,
  UsersSlice,
} from '@hefe/store';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import CustomForm from '../../../core/components/form/custom-form';

interface LinkedUserAccountsFormProps {
  user: User;
}

export default function LinkedUserAccountsForm(
  props: LinkedUserAccountsFormProps
) {
  const dispatch = useAppDispatch();
  const currentUser = useSelector(currentUserSelector);
  const users = useSelector(BasketballUsersSlice.basketballUsersSelector);
  const [isSaving, setSaving] = useState(false);

  const submit = (values: any, resetForm: any) => {
    setSaving(true);
    dispatch(
      UsersSlice.updateUserChildren({
        id: props.user.id,
        child_ids: values.children,
        basketball: true,
      })
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setSaving(false));
  };

  const usersSelect: SelectOption[] = users
    .filter((user) => user.id !== props.user.id)
    .map((user) => {
      return {
        label: user.firstname + ' ' + user.lastname,
        value: user.id,
      };
    });

  return (
    <CustomForm
      key={`edit-user-roles-${props.user.id}`}
      loading={isSaving}
      fields={[
        {
          name: 'children',
          label: '',
          placeholder: t('select'),
          rules: [],
          initalValue: props.user.child_users.map((cu) => cu.id),
          multiSelect: true,
          selectOptions: usersSelect,
          disableSelectClear: true,
          extraLabel: t('linked_accounts_info'),
          type: 'select',
        },
      ]}
      onSubmit={submit}
    />
  );
}
